module.exports = __webpack_public_path__ + "static/img/btn_go.c3f711f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lottery/btn_go.png
// module id = pp7T
// module chunks = 1